import { Typography } from '@execonline-inc/execonline-ui';
import { NotTranslated } from '@execonline-inc/translations';
import { observer } from 'mobx-react';
import { T } from '../../Translations';

function CopyrightNotice() {
  const currentYear: number = new Date().getFullYear();

  return (
    <Typography
      data-testid="footer_copyright-notice"
      className="text-foreground"
      variant="bodyMedium"
    >
      <NotTranslated text={`© ${currentYear} ExecOnline.`} /> <T kind="All rights reserved" />
    </Typography>
  );
}

export default observer(CopyrightNotice);
